"use client";

import type { TextColor } from "@homeinstead/schemas";

import { cn } from "@homeinstead/ui";
import { inquiryTextColorClass } from "./inquiry-text-color";

type InquiryStepHeadingProps = {
  children: string;
  className?: string;
  textColor?: TextColor;
};

function InquiryStepHeading({
  children,
  className,
  textColor,
}: InquiryStepHeadingProps) {
  return (
    <h2
      className={cn(
        "text-left font-bold font-jakarta",
        "text-xl md:text-1xl",
        inquiryTextColorClass(textColor),
        className,
      )}
    >
      {children}
    </h2>
  );
}

export { InquiryStepHeading };
